import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const values = [
  { icon: 'ri-heart-fill', title: 'クリエイティビティ', desc: '常に革新的な発想で、クライアントの期待を超えるアイデアを生み出します。', color: '#F472B6', bg: '#FFF0F7', emoji: '💡' },
  { icon: 'ri-bar-chart-2-fill', title: '結果へのコミットメント', desc: '美しいデザインだけでなく、ビジネス成果に直結するソリューションを提供します。', color: '#38BDF8', bg: '#E0F7FF', emoji: '🚀' },
  { icon: 'ri-links-fill', title: '信頼関係', desc: 'クライアントとの長期的なパートナーシップを大切に、誠実に向き合います。', color: '#A3E635', bg: '#F3FFEA', emoji: '🤝' },
  { icon: 'ri-refresh-fill', title: '継続的な進化', desc: '業界トレンドを常にキャッチアップし、最新の手法でブランドを支援します。', color: '#FBBF24', bg: '#FFFBEB', emoji: '✨' },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <section className="relative pt-36 pb-20 overflow-hidden" style={{ background: 'linear-gradient(135deg, #38BDF8 0%, #F472B6 60%, #FBBF24 100%)' }}>
        <div className="absolute top-10 right-20 w-40 h-40 bg-white/10 rounded-full" />
        <div className="absolute bottom-0 left-10 w-32 h-32 bg-white/10 rounded-full" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 text-white text-xs font-black px-4 py-2 rounded-full mb-6 uppercase tracking-wider backdrop-blur-sm">
            🏢 About Us
          </div>
          <h1 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight drop-shadow-sm">私たちについて</h1>
          <p className="text-white/90 text-sm md:text-base leading-relaxed max-w-2xl mx-auto font-medium">
            大阪から世界へ。Grandeur Architectは広告代理店の枠を超えた、クリエイティブパートナーです。
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8">会社概要 📋</h2>
              <table className="w-full text-sm">
                <tbody>
                  {[
                    { label: '会社名', value: 'Grandeur Architect株式会社' },
                    { label: '設立', value: '令和3年7月21日（2021年7月21日）' },
                    { label: '代表者', value: '山内　紫央里' },
                    { label: '所在地', value: '〒530-0043 大阪市北区天満四丁目１４番２ー５０２号' },
                    { label: 'メール', value: 'info.customer@grandeur-architect.com' },
                    { label: '電話番号', value: '050-8895-1393 / 080-2943-2049' },
                    { label: '事業内容', value: '広告代理店業務及び各種の宣伝に関する業務' },
                  ].map((row, i) => (
                    <tr key={row.label} className="border-b border-gray-100">
                      <td className="py-4 pr-8 font-black text-xs w-32 align-top" style={{ color: ['#38BDF8','#F472B6','#FBBF24','#A3E635','#FB923C','#C084FC'][i] }}>{row.label}</td>
                      <td className="py-4 text-gray-700 font-medium text-sm">{row.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="relative h-80 md:h-96 flex items-center justify-center overflow-hidden rounded-3xl" style={{ background: 'linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #0F172A 100%)' }}>
              {/* Stars background */}
              {[...Array(28)].map((_, i) => (
                <div
                  key={i}
                  className="absolute rounded-full bg-white"
                  style={{
                    width: `${[1,2,1,3,1,2,1,2,3,1,2,1,2,1,3,1,2,1,2,1,1,2,1,2,3,1,2,1][i] || 1}px`,
                    height: `${[1,2,1,3,1,2,1,2,3,1,2,1,2,1,3,1,2,1,2,1,1,2,1,2,3,1,2,1][i] || 1}px`,
                    top: `${(i * 37 + 5) % 95}%`,
                    left: `${(i * 53 + 7) % 95}%`,
                    opacity: 0.4 + (i % 5) * 0.12,
                  }}
                />
              ))}

              {/* Orbit rings */}
              <div className="absolute w-52 h-52 rounded-full border border-[#38BDF8]/30 animate-spin" style={{ animationDuration: '18s' }} />
              <div className="absolute w-72 h-72 rounded-full border border-dashed border-[#F472B6]/25 animate-spin" style={{ animationDuration: '28s', animationDirection: 'reverse' }} />
              <div className="absolute w-[340px] h-[340px] rounded-full border border-[#A3E635]/15 animate-spin" style={{ animationDuration: '38s' }} />

              {/* Orbiting objects on ring 1 */}
              <div className="absolute w-52 h-52 animate-spin" style={{ animationDuration: '18s' }}>
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 rounded-full bg-[#38BDF8] flex items-center justify-center">
                  <i className="ri-star-fill text-white" style={{ fontSize: '10px' }} />
                </div>
              </div>

              {/* Orbiting objects on ring 2 */}
              <div className="absolute w-72 h-72 animate-spin" style={{ animationDuration: '28s', animationDirection: 'reverse' }}>
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-[#FBBF24] flex items-center justify-center shadow-lg">
                  <i className="ri-star-fill text-white" style={{ fontSize: '13px' }} />
                </div>
                <div className="absolute top-1/2 -right-3 -translate-y-1/2 w-5 h-5 rounded-full bg-[#F472B6]" />
              </div>

              {/* Orbiting objects on ring 3 */}
              <div className="absolute w-[340px] h-[340px] animate-spin" style={{ animationDuration: '38s' }}>
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-5 h-5 rounded-full bg-[#A3E635]" />
                <div className="absolute top-1/2 -left-3 -translate-y-1/2 w-4 h-4 rounded-full bg-[#C084FC]" />
                <div className="absolute -bottom-2 left-1/3 w-3 h-3 rounded-full bg-[#FB923C]" />
              </div>

              {/* Main planet */}
              <div className="relative z-10 flex flex-col items-center gap-3">
                <div className="w-28 h-28 rounded-full flex items-center justify-center relative" style={{ background: 'linear-gradient(135deg, #38BDF8 0%, #F472B6 60%, #FBBF24 100%)' }}>
                  {/* Planet ring */}
                  <div className="absolute w-40 h-8 border-2 border-[#FBBF24]/70 rounded-full rotate-12" />
                  <i className="ri-earth-fill text-white" style={{ fontSize: '52px' }} />
                </div>
                <div className="flex gap-2 mt-1">
                  {['#38BDF8', '#F472B6', '#FBBF24', '#A3E635', '#C084FC'].map((c, i) => (
                    <div key={i} className="w-2 h-2 rounded-full animate-pulse" style={{ background: c, animationDelay: `${i * 0.3}s` }} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20" style={{ background: '#F8F9FF' }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">私たちの価値観 🌟</h2>
            <p className="text-gray-500 text-sm max-w-lg mx-auto font-medium">すべての仕事において、これらのコアバリューを大切にしています。</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) => (
              <div key={v.title} className="rounded-3xl p-6 text-center hover:-translate-y-1 transition-transform" style={{ background: v.bg }}>
                <div className="text-3xl mb-3">{v.emoji}</div>
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl mx-auto mb-4 bg-white">
                  <i className={`${v.icon} text-xl`} style={{ color: v.color }} />
                </div>
                <h3 className="font-black text-gray-900 text-base mb-2">{v.title}</h3>
                <p className="text-gray-600 text-xs leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 text-center" style={{ background: 'linear-gradient(135deg, #38BDF8, #F472B6)' }}>
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="text-3xl font-black text-white mb-4">一緒に働きませんか？🎉</h2>
          <p className="text-white/80 text-sm mb-8 font-medium">一緒に最高のブランドを作りましょう。まずはお気軽にご連絡ください。</p>
          <Link to="/contact" className="inline-flex items-center gap-2 bg-white text-gray-900 font-black px-8 py-3.5 rounded-full cursor-pointer hover:scale-105 transition-all whitespace-nowrap">
            お問い合わせ <i className="ri-arrow-right-up-line" />
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
